<template lang="pug">
  include ../mixins
  star-rating.vue-star-rating(
    :increment="1",
    :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
    :round-start-rating="false",
    :star-size="24",
    active-color="#AF3D20",
    inactive-color="#E7E0DC"
    :fixed-points="1",
    :rating="rating"
    :read-only="true"
  )
</template>

<script>
export default {
  props: {
    rating: {
      type: Number,
    },
  },
}
</script>
